/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useState } from "react";
import api from "../../../../base/services/ResApi";
import OrgsFormModal from "./OrgsFormModal";
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling";
import buildings from "../../../../../resources/buildings.png";

const CreateNewOrgsModal = ({ open, onClose, setUpdateData }) => {
  const [data, setData] = useState([])
  const [updatedValues, setUpdatedValues] = useState([])
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])
  const [isBtnLoading, setIsBtnLoading] = useState(false)

  const [profilePic, setProfilePic] = useState(buildings)

  const [iserror, setIserror] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])
  const [iserrorShow, setIserrorShow] = useState(false)

  // Contact validations
  const [isPrimContactValid, setIsPrimContactValid] = useState(false)
  const [primErrorMessage, setPrimErrorMessage] = useState()
  const [isSecContactValid, setIsSecContactValid] = useState(false)
  const [secErrorMessage, setSecErrorMessage] = useState()

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsBtnLoading(true)
    setPrimErrorMessage()
    setIsPrimContactValid(false)
    setSecErrorMessage()
    setIsSecContactValid(false)

    const primContact = data.primContact
    const secContact = data.secContact

    if (primContact && (primContact.length < 10 || primContact.length > 20)) {
      setPrimErrorMessage(
        "Primary contact should be between 10 and 20 characters."
      )
      setIsPrimContactValid(true)
      setIsBtnLoading(false)
    } else if (
      secContact &&
      (secContact.length < 10 || secContact.length > 20)
    ) {
      setSecErrorMessage(
        "Secondary contact should be between 10 and 20 characters."
      )
      setIsSecContactValid(true)
      setIsBtnLoading(false)
    } else if (primContact && primContact === secContact) {
      setPrimErrorMessage("Primary and secondary contacts should not be equal.")
      setSecErrorMessage("Primary and secondary contacts should not be equal.")
      setIsPrimContactValid(true)
      setIsSecContactValid(true)
      setIsBtnLoading(false)
    } else {
      handleCreateOrg()
    }
  }

  const handleCreateOrg = () => {
    let postConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
    const payload = {
      orgName: data.orgName,
      primAddress: data.primAddress,
      secAddress: data.secAddress,
      email: data.email,
      primContact: data.primContact,
      secContact: data.secContact,
      description: data.description,
    }

    const newOrg = new Blob([JSON.stringify(payload)], {
      type: "application/json",
    })

    const formData = new FormData()
    formData.append("organization_details", newOrg)
    formData.append("organization_logo", profilePic)

    api
      .post("/organizations", formData, postConfig)
      .then((res) => {
        setErrorMessages([])
        setIserror(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setUpdateData(true)
        handleClear()
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setIsSuccess(false)
        setIserror(true)
        setErrorMessages([
          error.response.data.description
            ? error.response.data.description
            : "Role Creation Failed",
        ])
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow
        )
      })
  }

  const handleClear = () => {
    setData([])
    setPrimErrorMessage()
    setIsPrimContactValid(false)
    setSecErrorMessage()
    setIsSecContactValid(false)
    setTimeout(() => {
      onClose()
      setIsSuccess(false)
      setSuccessMessages([""])
      setIserror(false)
      setErrorMessages([])
      setIsBtnLoading(false)
    }, 3000)
  }

  return (
    <OrgsFormModal
      open={open}
      data={data}
      setData={setData}
      updatedValues={updatedValues}
      setUpdatedValues={setUpdatedValues}
      isSuccess={isSuccess}
      successMessages={successMessages}
      iserrorShow={iserrorShow}
      iserror={iserror}
      setIserror={setIserror}
      errorMessages={errorMessages}
      setErrorMessages={setErrorMessages}
      isLoading={false}
      handleSubmit={handleSubmit}
      isPrimContactValid={isPrimContactValid}
      primErrorMessage={primErrorMessage}
      isSecContactValid={isSecContactValid}
      secErrorMessage={secErrorMessage}
      handleClear={handleClear}
      isBtnLoading={isBtnLoading}
      title="Create Organization"
      orgNameDisabled={false}
      setProfilePic={setProfilePic}
      profilePic={profilePic}
      onClose={onClose}
    />
  )
}

export default CreateNewOrgsModal;
